import { StateCreator } from "zustand";

import { UtilityBarSliceType } from "@/state/@types";

export const createUtilityBarSlice: StateCreator<
  UtilityBarSliceType,
  [],
  [],
  UtilityBarSliceType
> = (set, get) => ({
  // initial state
  refetch: null,
  sortableDefinitions: {},
  sortables: [],
  filterDefinitions: {},
  filters: [],
  openFilterKey: null,
  availableOperators: [],
  // actions
  setRefetch: (refetchFn) => set({ refetch: refetchFn }),
  setSortableDefinitions: (definitions) =>
    set({ sortableDefinitions: definitions }),
  setFilterDefinitions: (definitions) =>
    set({ filterDefinitions: definitions }),
  setFilters: (filters) => set({ filters }),
  setSortables: (sortables) => {
    const sortableDefinitions = get().sortableDefinitions;
    const newSortables = sortables.map((sortable) => {
      const sortableDefinition = sortableDefinitions[sortable.key];
      return {
        ...sortable, // Spread existing sortable properties
        value: sortableDefinition?.operators?.[0]?.key,
      };
    });
    set({ sortables: newSortables });
  },
  setAvailableOperators: (operators) => set({ availableOperators: operators }),
});
